import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';

export const ItemImage = () => {
  const { image } = useSettings();
  const hasImage = !!image?.url;

  if (!hasImage) {
    return null;
  }

  return (
    <ImageContainer>
      <Image _imageUrl={image.url} />
    </ImageContainer>
  );
};

const ImageContainer = styled.div.attrs({
  className: `${meta.prefix}-item-image-imageContainer`
})`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
  flex-shrink: 0;
`;

const Image = styled.div.attrs({
  className: `${meta.prefix}-item-image-image`
})`
  max-width: 100%;
  background-size: cover;
  background-position: center;
  height: 100%;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  display: block;
  background-image: ${({ _imageUrl }) =>
    _imageUrl ? `url(${_imageUrl})` : 'none'};
`;
